import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAARElEQVR42oWNMQqAQAzA7v9vc3DrUkqLiygW6qoYQRycvEC2QBr/nI3rgGVgmwRVxd0RETLzE6wj+6xExKOZUVVv0Fnc13V7kfrARtAAAAAASUVORK5CYII="};
